<div #mapComponent class="autocomplete-container">
  <input
    id="autocomplete"
    type="text"
    placeholder="Ex. Central Park, New York, NY, USA"
    class="form-control"
  />
</div>
<div id="map" style="height: 400px; margin-top: 10px"></div>
